import Vue from 'vue';
import {
  default as Vuedals
} from 'vuedals-submit';
// , Component as Vuedal, Bus as VuedalsBus
Vue.use(Vuedals);
